// extracted by mini-css-extract-plugin
export var container = "styles-module--container--26cea";
export var media = "styles-module--media--978ac";
export var orderedListItem = "styles-module--orderedListItem--d4345";
export var unorderedListItem = "styles-module--unorderedListItem--963d5";